module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "noindents1"
  }, [_c('a', {
    attrs: {
      "id": "ch00_fm06_pre1"
    }
  }), _c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _vm._v(" "), _c('em', [_vm._v("Author’s note.")]), _vm._v(" This book is wholly fiction. Any resemblance to the present or past is gratuitous and similarity to any actual event or character is accidental and not intended."), _c('a', {
    attrs: {
      "id": "page_xii"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f952ccee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm06_pre1.vue
// module id = 78
// module chunks = 0